import React from 'react';
import ForgotPasswordForm from '../../components/ForgotPasswordForm/ForgotPasswordForm';
import { Container } from 'reactstrap';

const ForgotPassword = () => {
  return (
    <Container>
      <ForgotPasswordForm />
    </Container>
  );
};

export default ForgotPassword;
